import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { updateMOMSSsOnContractIfContractWasAccepted } from '../orderMSServices/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getContractListData,
  getContractDataById,
  propagateContractAdditions,
  propagateContractChanges,
  propagateContractDeletions,
} from './mockData'
import type { IContract } from '~/types/contract/models'

interface GetContractsResponse {
  data: IContract[]
}

const getContracts = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  console.log(`'Returning contracts.`)
  const responseBody: GetContractsResponse = {
    data: await getContractListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getContract(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning data for contract id "${id}".`)
  const data = await getContractDataById(id)
  return res(ctx.status(200), ctx.json({ data }))
}

const postContract = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getContractListData,
    undefined,
    propagateContractAdditions
  )
}

const patchContract = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getContractListData, [
    updateMOMSSsOnContractIfContractWasAccepted,
    propagateContractChanges,
  ])
}

const deleteContract = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getContractListData,
    undefined,
    propagateContractDeletions
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/contracts',
    handler: getContracts,
  },
  {
    method: 'get',
    path: '/api/contracts/:id',
    handler: getContract,
  },
  {
    method: 'post',
    path: '/api/contracts',
    handler: postContract,
  },
  {
    method: 'patch',
    path: '/api/contracts/:id',
    handler: patchContract,
  },
  {
    method: 'delete',
    path: '/api/contracts/:id',
    handler: deleteContract,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
